'use client';

import { 
  Database, ShieldCheck, Zap, Bot, Store, 
  Building2, Cloud, ArrowUpRight, Cpu, Lock, 
  Sparkles, CheckCircle2 
} from 'lucide-react';
import styles from './BentoEcosystem.module.css';

const DIFFERENTIALS = [
  {
    id: 'postgres',
    size: 'large',
    badge: 'ARQUITETURA DEDICADA',
    title: 'PostgreSQL HA com Isolamento Real por Tenant',
    desc: 'Ao contrário de outros ERPs que misturam todos os clientes no mesmo banco, o Aesir roda um banco de dados dedicado com Patroni HA para cada empresa. Seus dados nunca se misturam com concorrentes.',
    icon: Database,
    color: '#0284c7',
    bg: '#e0f2fe',
    highlight: '99.99% Integridade',
    tag: 'Patroni HA + Raft'
  },
  {
    id: 'whatsapp',
    size: 'medium',
    badge: 'ALTA VAZÃO',
    title: 'WhatsApp Hub Anti-Bloqueio',
    desc: 'Criptografia direta ponta a ponta com HKDF e aquecedor de chips automatizado. Múltiplos atendentes no mesmo número sem desconexões chatas.',
    icon: Zap,
    color: '#10b981',
    bg: '#d1fae5',
    highlight: 'Zero Banimento',
    tag: 'Aquecedor Nativo'
  },
  {
    id: 'ai',
    size: 'medium',
    badge: 'INTELIGÊNCIA ARTIFICIAL',
    title: 'Odin IA: Vendedor 24 Horas',
    desc: 'Agente treinado com todo o seu estoque, tabela de preços e regras de negócio. Atende, tira dúvidas, quebra objeções e gera links Pix automáticos.',
    icon: Bot,
    color: '#8b5cf6',
    bg: '#ede9fe',
    highlight: 'Respostas em 1.2s',
    tag: 'Odin LLM Engine'
  },
  {
    id: 'multitenant',
    size: 'medium',
    badge: 'ESCALABILIDADE',
    title: 'Multi-Empresas e Multi-Filiais',
    desc: 'Gerencie matriz e filiais em uma única sessão. Troque de empresa com 1 clique sem precisar deslogar ou pagar taxas extras abusivas.',
    icon: Building2,
    color: '#ea580c',
    bg: '#ffedd5',
    highlight: '1 Clique para Alternar',
    tag: 'Sessão Unificada'
  },
  {
    id: 'pdv',
    size: 'medium',
    badge: 'VELOCIDADE MÁXIMA',
    title: 'PDV & Emissão Fiscal em Lote',
    desc: 'Frente de caixa ultra-rápida. Emissão de NFC-e e NF-e homologada na SEFAZ com envio automático do PDF e XML no WhatsApp do cliente.',
    icon: Store,
    color: '#f59e0b',
    bg: '#fef3c7',
    highlight: 'Emissão < 1s',
    tag: 'Certificado A1'
  },
  {
    id: 'cloud',
    size: 'large',
    badge: 'ALTA DISPONIBILIDADE',
    title: 'Cluster Docker Swarm na Nuvem',
    desc: 'Infraestrutura distribuída com redundância em múltiplos servidores. Backup diário criptografado e atualizações contínuas sem tirar o seu negócio do ar.',
    icon: Cloud,
    color: '#4f46e5',
    bg: '#e0e7ff',
    highlight: '99.9% Uptime',
    tag: 'Cluster Redundante'
  }
];

export function BentoEcosystem() {
  return (
    <section className={styles.section} id="diferenciais">
      <div className={styles.container}>
        
        {/* CABEÇALHO */}
        <div className={styles.header}>
          <div className={styles.badgeTop}>
            <Sparkles size={14} />
            <span>ENGENHARIA DE PONTA</span>
          </div>
          <h2 className={styles.title}>
            Por que os líderes de mercado <br />
            <span className={styles.titleHighlight}>migram para o Aesir ERP?</span>
          </h2>
          <p className={styles.subtitle}>
            Não somos apenas um ERP com telas bonitas. Por trás da interface Material You 3, 
            existe uma infraestrutura de nível bancário projetada para não travar a sua operação.
          </p>
        </div>

        {/* BENTO GRID */}
        <div className={styles.grid}>
          {DIFFERENTIALS.map((item) => {
            const Icon = item.icon;
            const isLarge = item.size === 'large';

            return (
              <div 
                key={item.id} 
                className={`${styles.card} ${isLarge ? styles.cardLarge : styles.cardMedium}`}
              >
                <div className={styles.cardHeader}>
                  <div className={styles.iconCircle} style={{ background: item.bg, color: item.color }}>
                    <Icon size={24} />
                  </div>
                  <div className={styles.tagPill}>
                    {item.tag}
                  </div>
                </div>

                <div className={styles.cardBody}>
                  <span className={styles.cardBadge} style={{ color: item.color }}>
                    {item.badge}
                  </span>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardDesc}>{item.desc}</p>
                </div>

                <div className={styles.cardFooter}>
                  <div className={styles.highlightBadge}>
                    <CheckCircle2 size={14} color="#10b981" />
                    <span>{item.highlight}</span>
                  </div>
                  <div className={styles.cardLink}>
                    <ArrowUpRight size={18} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}